<template>
  <v-app class="bg-secondary">
    <v-main class="pb-4 bg-white">
    
        <v-toolbar  v-if="mdAndUp" flat max-width="100%" :class="{ dense_toolbar: xs }"  height="65" class="bg-transparent">
          <div class="toolbar-shell">
            <router-link to="/" class="d-flex align-center logo-link">
              <v-img
                :src="logo"
                max-height="80"
                contain
                class="logo-img"
              />
            </router-link>

            <div class="toolbar-center">
              <div class="menu-items">
                <template  v-for="(item, i) in menu"
                  :key="'menu' + i">
                  <v-btn
                    variant="text"
                    :to="item.to"
                    style="height: 64px; letter-spacing: -0.02em;"
                    :href="item.href"
                    :target="item.target"
                    :width="xs ? 100 / menu.length + 'vw' : undefined"
                    :class="{ 'text-black font-weight-bold': route.path === item.to }"
                    v-text="item.title"
                    class="text-center primary font-weight-regular"
                  />
                  <v-divider
                    v-if="i < menu.length - 1"
                    length="15"
                    vertical
                    color="primary"
                    variant="solid"
                    thickness="3"
                    class="mx-2 my-auto"
                    opacity="0.9"
                    style="border-radius: 4px"
                  ></v-divider>
                </template>
              </div>

              <div class="toolbar-actions">
                <v-btn
                  class="bg-primary support-btn"
                  to="/podporit"
                  height="24"
                  size="small"
                  block
                  style="z-index: 5; white-space:nowrap;"
                >
                  Podporiť
                </v-btn>

                <div class="toolbar-search-wrap">
                  <v-text-field
                    v-model="searchData"
                    hide-details
                    @keydown="searchKeydown"
                    @click:append-inner="search"
                    variant="outlined"
                    density="compact"
                    class="searchBar toolbar-search"
                    single-line
                    autocomplete="off"
                  >
                    <template #append-inner>
                      <v-icon size="12" @click="search" class="cursor-pointer">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>
          </div>
        </v-toolbar>
        
      <v-app-bar v-if="smAndDown" flat>
        <router-link to="/" class="d-flex align-center">
          <v-img
            :src="logo"
            max-height="32"
            contain
            class="logo-img"
          />
        </router-link>
        <v-spacer />
        <v-app-bar-nav-icon color="primary" @click="drawer = !drawer" />  
      </v-app-bar>

      <!-- DRAWER -->
      <v-navigation-drawer
        v-model="drawer"
        temporary
        location="right"
      >
        <!-- SEARCH -->
        <div class="pa-3">
          <v-text-field
            v-model="searchData"
            placeholder="Hľadať..."
            clearable
            hide-details
            density="compact"
            variant="outlined"
            @keydown="searchKeydown"
          >
            <template #append-inner>
              <v-icon @click="search">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </div>

        <v-divider />

        <!-- MENU ITEMS -->
        <v-list>
          <v-list-item
            v-for="(item, i) in menu"
            :key="i"
            :to="item.to"
            :href="item.href"
            :target="item.target"
            @click="drawer = false"
          >
            <v-list-item-title v-text="item.title" />
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
         
        

      <v-card
        v-if="0"
        ripple
        style="cursor: pointer;width:1000px "
        to="/2-percenta-dani"
        class="flat display-2 pa-4 primary text-white" 
        :class="{
          'display-2 pl-10': smAndUp,
          'headline': xs
        }"
      >
        <v-row style="max-width: 1000px; margin: auto;">
          <v-col class="pa-0" align-self="center" >
            Darujte 2 % daní pre <div class="black--text">Investigatívne Centrum Jána Kuciaka</div>
          </v-col>
          <v-col class="shrink pa-0">
            <v-img max-width="128" style="border-radius: 100%;width:1000px " :src="require('./assets/img_icjk_baner_2percenta.jpg')"/>
          </v-col>
        </v-row>
      </v-card>
      <RouterView
      :key="route.path"
      ></RouterView>
<!-- <v-row justify="center" class="bg-white" :class="{'pt-4 pb-8':!loadingContent}" >
       <v-btn 
        v-if="route.fullPath.indexOf('/cookies') !== -1"
        color="primary"
        @click="resetCookies"
      >
        Resetovať cookies
      </v-btn>     
          </v-row>-->
      

    </v-main>
   

<div class="background-ring"></div>
    <v-footer class="d-flex flex-column bg-secondary px-sm-8 ga-2 py-4" :class="{ 'px-4': smAndDown }">
      <v-row class="footer-grid" >
          <v-col 
            class="d-flex flex-wrap align-center"
            :class="smAndDown ? 'justify-center text-center' : 'justify-start'">
          <template  v-for="(item, i) in footer"
                :key="'menu' + i">

                <v-btn
                  variant="text"
                  :to="item.to"
                  :href="item.href"
                  :target="item.target"
                  class="footer-btn"
                  :class="{ 'text-white font-weight-white': route.path === item.to }"
                >
              {{ item.title }}
            </v-btn>

            <v-divider
              vertical
              length="15"
              color="primary"
              thickness="3"
              class="mx-2 my-auto"
              opacity="0.9"
              style="border-radius: 4px"
            />

          </template>
          </v-col>
      </v-row>     
         
          <div class="text-center text-accent caption mt-4" :class="{ 'font-size-small': smAndDown }">
                Investigatívne centrum Jána Kuciaka
              
                P.O.BOX 8/D
                
                810 00 Bratislava 1
                
                IČO 51820897
                
                EV 80/23/SWP
          </div>
        
           <div class="text-center mt-4 mb-8 social-icons">
                <a href="https://www.facebook.com/icjk.sk" target="_blank" class="text-secondary social-icons"><img height="48" style="vertical-align: middle;" :src="require('./assets/facebook.svg')" class="mx-2"></a>
                  
                <a href="https://www.instagram.com/icjk.sk/" target="_blank" class="text-secondary"><img height="48" style="vertical-align: middle;" :src="require('./assets/instagram.svg')" class="mx-2"></a>
                  
                <a href="https://www.youtube.com/channel/UCPQY77IlYZN_wwSXpfipXHA" target="_blank" class="text-secondary"><img height="48" style="vertical-align: middle;" :src="require('./assets/youtube.svg')" class="mx-2"></a>
                  
                <a href="https://twitter.com/ICJK_sk" target="_blank" class="text-secondary"><img height="48" style="vertical-align: middle;" :src="require('./assets/x-twitter.svg')" class="mx-2"></a>
                 
                <a href="https://sk.linkedin.com/company/investigativne-centrum-jana-kuciaka" target="_blank" class="text-secondary"><img height="48" style="vertical-align: middle;" :src="require('./assets/linkedin.svg')" class="mx-2"></a>
                  
            </div>
           <div
              :class="{
                'd-flex justify-center align-center flex-wrap': !smAndDown,
                'flex-column text-center': smAndDown
              }"
              class="mt-4"
            >
            <h4 class="text-accent mb-2">PARTNERI</h4>
            <v-divider
                v-if="mdAndUp"
                length="15"
                vertical
                color="accent"
                variant="solid"
                thickness="3"
                class="mx-3 my-auto "
                opacity="0.9"
                style="border-radius: 4px"
                  ></v-divider>
              <a
                v-for="partner in partners"
                :key="partner.link"
                :href="partner.link"
                target="_blank"
                :class="{ 'mx-3': mdAndUp, 'mx-2 my-2': smAndDown }"
              >
                <img
                  :src="partner.img"
                  :title="partner.title"
                   style="max-width: 100%; max-height: 40px; filter: grayscale(1) opacity(0.6) brightness(1.1)"
                />
              </a>
            </div>
         <div
          :class="{
            'd-flex justify-center align-center flex-wrap': !smAndDown,
            'flex-column text-center': smAndDown
          }"
          class="mt-4"
        >
                <h4 class="text-accent">ICJK PODPORUJÚ</h4> 
                  <v-divider
                    v-if="mdAndUp"
                    length="15"
                    vertical
                    color="accent"
                    variant="solid"
                    thickness="3"
                    class="mx-3 my-auto "
                    opacity="0.9"
                    style="border-radius: 4px"
                  ></v-divider>
                    <a 
                      v-for="(supporter) in supporters"
                      :key="supporter.link"
                      :href="supporter.link"
                      target="_blank"
                      class="text-center d-inline-block"
                      :class="{ 'mx-3': mdAndUp, 'mx-2 my-3': smAndDown }"
                      
                    >
                      <img 
                        :src="supporter.img ?? null" 
                        :title="supporter.title"
                         style="max-width: 100%; max-height: 40px; filter: grayscale(1) opacity(0.6) brightness(1.1)"
                      />
                    </a>
            </div>
    </v-footer>
   
    <!-- <v-card 
      v-if="supportDialog"
      :width="smAndDown ? 'auto' : '290'"
      style="position: fixed; right: 8px; bottom: 8px;"
      :class="{ 'ma-4': smAndDown }"
    >
      <v-card-title primary-title class="title bg-primary text-white py-2">
        <v-row>
          <v-col cols="10" class="py-0 pr-0">
            Podporte Investigatívne<br>
            centrum Jána Kuciaka
          </v-col>
          <v-col cols="2" class="shrink pa-0 pr-2 text-right">
            <v-btn variant="text" small icon dark @click="closeSupportDialog"><v-icon small>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="caption text-justify pt-3">
        <div class="subtitle-2">Naša spoločnosť nevyhnutne potrebuje investigatívnu žurnalistiku.</div> My v Investigatívnom centre Jána Kuciaka ju robíme nezávislo a pokračujeme v jeho odkaze spolupráce a hľadania pravdy. Spoločne s inými médiami napríklad analyzujeme dáta takzvanej Kočnerovej knižnice a prichádzame s novými odhaleniami. Nešlo by to však bez Vašej podpory. Vaše dary posilňujú našu nezávislosť.
      </v-card-text>
      <v-card-actions class="pa-4 pt-0">
        <v-btn block to="/226/Podporte-nas" variant="elevated" color="primary" dark @click="supportDialog = false" >Podporiť</v-btn>
      </v-card-actions>
    </v-card> -->
  
  <v-btn
    v-show="showScrollTop"
    icon
    class="scroll-to-top"
    @click="scrollToTop"
    elevation="8"
    variant="outline"
  >
    <v-icon>mdi-chevron-double-up</v-icon>
  </v-btn>   
  </v-app>
</template>


<script setup>
import logo from '@/assets/logo2.png'  
import { useDisplay } from 'vuetify'
import { useRoute, useRouter } from 'vue-router'
import { ref, computed, watch, onMounted, useTemplateRef, onUnmounted } from 'vue';
import VueCookies from 'vue-cookies'

const { xs, smAndUp, mdAndUp, smAndDown } = useDisplay()
const route = useRoute()
const router = useRouter()
console.log('route', route.fullPath)


// State
const drawer = ref(false)
const searchData = ref('')
const supportDialog = ref(false)
const group = ref(null)
const cookieBanner =  useTemplateRef('cookieBanner')

// Footer links
const footer = [
  {title: 'Etický kódex', to: '/ethics'},
  {title: 'O nás', to: '/about'},
  {title: `Podporte nás`, to: '/podporit'},
  {title: `Darujte 2%`, to: '/darujte-2-percenta'},
  {title: `Cookies`, to: '/cookies'},
  {title: `RSS`, href: '/rss', target: '_blank' },
  {title: `Ochrana osobných údajov`, to: '/gdpr'}
]

// Partner logos
const partners = [
  {img: new URL('./assets/investigaceCZ_logo.png', import.meta.url).href, title: 'Investigace.cz', link: 'https://www.investigace.cz/'},
  {img: new URL('./assets/OCCRP_logo.png', import.meta.url).href, title: 'Organized Crime and Corruption Reporting Project', link: 'https://www.occrp.org'},
  {img: new URL('./assets/vsquare-logoWhite.png', import.meta.url).href, title: 'VSQUARE.ORG', link: 'https://www.vsquare.org'},
  {img: new URL('./assets/globalInvestigativeWhite.png', import.meta.url).href, title: 'Global Investigative Journalism Network', link: 'https://www.gijn.org'},
  {img: new URL('./assets/rsf_logo.png', import.meta.url).href, title: 'Reporters Sans Frontières', link: 'https://rsf.org/en'}
]

// Supporters logos
const supporters = [
  {img: new URL('./assets/limelight-logo.png', import.meta.url).href, title: 'Limelight', link: 'https://limelight.foundation/', info: 'Podporené grantom Limelight' },
  {img: new URL('./assets/civitates_logo.svg', import.meta.url).href, title: 'Civitates', link: 'https://civitates-eu.org/', info: 'Podporené grantom Civitates' }
]

// Menu items
const menu = computed(() => {
  return [
    {title: 'Články', to: '/'},
    {title: 'O nás', to: '/about'},
   // {title: `Podporte nás`, to: '/226/Podporte-nas'},
    {title: `Podcast`, to: '/podcast'},
    {title: 'Bezpečná žurnalistika.sk', href: 'https://bezpecna.zurnalistika.sk',target:'_blank'},
    {title: `Darujte 2%`, to: '/darujte-2-percenta'}
  ]
})

// Methods
const search = () => {
  router.push('/search/' + searchData.value)
}

const searchKeydown = (e) => {
  if(e.keyCode == 13){
    search()
  }
}


// Watchers
watch(route, () => {
  window.scrollTo({
    top: 100,
    left: 100,
    behavior: 'smooth'
  })
  drawer.value = false
})

// Functions

function closeSupportDialog() {
  supportDialog.value = false
  VueCookies.set('preventSupportDialog', '1', '30d')
}

function resetCookies() {
  cookieBanner.value.removeCookie()
  window.location.reload()
}

const showScrollTop = ref(false)

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
// Lifecycle hooks
let rafId = null
const handleScroll = () => {
  const scrollY = window.scrollY

  // celková scrollovateľná výška stránky
  const bodyHeight = Math.max(document.body.scrollHeight - window.innerHeight, 1)

  // progress od 0 do 1
  const scrollRatio = Math.min(Math.max(scrollY / bodyHeight, 0), 1)

  // scroll-to-top button
  showScrollTop.value = scrollY > 300

  // výraznejší parallax - upraviteľné hodnoty
  const maxTranslate = 380 // px - väčší pohyb
  const verticalFactor = 1.2 // zvýrazní pohyb
  const horizontalMax = 80 // px horizontálny posun

  const bg = document.querySelector('.background-ring')
  if (!bg) return

  // batch DOM writes in RAF for smoothness
  if (rafId) cancelAnimationFrame(rafId)
  rafId = requestAnimationFrame(() => {
    const translateY = Math.round((scrollRatio * maxTranslate) * verticalFactor)
    //const translateX = Math.round((scrollRatio - 0.2) * horizontalMax) // slight horizontal shift
    bg.style.transform = `translateY(${translateY}px)`
  })
}
onMounted(() => {
  if (JSON.parse(localStorage.getItem('preventSupportDialog') || 'false') !== true) {
    supportDialog.value = true
  }

  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

</script>
<style>
  @import '../node_modules/vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
</style>
<style scoped>
.searchBar >>> .v-field__input{
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 8px;
    min-height: 22px;
}
.searchBar :deep(.v-field__overlay) {
  background: white;
}

.searchBar :deep(.v-field__input input::selection) {
  background: rgba(0, 0, 0, 0.15);
}

.toolbar-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(1400px, 100%);
  margin: 0 auto;
  gap: 20px;
}

.logo-link {
  flex: 0 0 auto;
}

.toolbar-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 18px;
  min-width: 0;
}

.menu-items {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  min-width: 0;
  flex: 1 1 auto;
  gap: 0;
  overflow: hidden;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding-left: 24px;
  margin-left: 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  flex: 0 0 auto;
}

.support-btn {
  flex: 0 0 auto;
  min-width: 110px;
  max-width: 130px;
}

.toolbar-search-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(220px, 100%);
  flex: 0 0 auto;
}

.toolbar-search {
  min-width: 160px;
  width: 100%;
}

@media (min-width: 600px) and (max-width: 1279px){
  .toolbar-shell { gap: 12px; }
  .toolbar-search { min-width: 180px; }
}

</style>
